// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZnLc","label":"styles_label__1ytOb"};